export default __webpack_public_path__ + "static/index-6701786bbc3c2b95167563750d733eb7.jpg";